import React from "react";
import PropTypes from "prop-types";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Transition for the dialog
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function TutorialStep({ open, onClose, title = "", description, content, actions, children, maxWidth = "md" }) {
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={onClose}
            aria-labelledby="tutorial-dialog-title"
            aria-describedby="tutorial-dialog-description"
            maxWidth={maxWidth}
            fullWidth
            sx={{ zIndex: 1600 }} // Ensure it appears above other blocking modals (e.g. ConnectOwnProfile)
        >
            <MDBox p={3} pb={0}>
                <MDTypography variant="h4" fontWeight="medium" textTransform="capitalize">
                    {title}
                </MDTypography>
                {description && (
                    <MDTypography variant="body2" color="text" mt={1}>
                        {description}
                    </MDTypography>
                )}
            </MDBox>

            <DialogContent>
                {content || children}
            </DialogContent>

            {actions && (
                <DialogActions sx={{ padding: "1.5rem" }}>
                    {actions}
                </DialogActions>
            )}
        </Dialog>
    );
}

TutorialStep.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.node,
    actions: PropTypes.node,
    children: PropTypes.node,
    maxWidth: PropTypes.string,
};

export default TutorialStep;
